

















































import { Component, Vue } from 'vue-property-decorator';
import QRatingFace from './partials/QRatingFace.vue';
import { mapState } from 'vuex';

@Component({
  components: {
    QRatingFace,
  },
  computed: {
    ...mapState('Auth', {
      activeBusiness: 'activeBusiness',
    }),
    ...mapState({
      loading: 'loading',
    }),
    ...mapState('Feedback', {
      popup: 'popup',
    }),
  },
})
export default class QFeedbackPopup extends Vue {
  rating = null;
  message = '';

  activeBusiness!: Model;

  handleSubmit() {
    this.$store
      .dispatch('Feedback/create', {
        object_id: this.activeBusiness.object_id,
        payload: {
          rating: this.rating,
          message: this.message,
        },
      })
      .then(() => {
        this.closePopup();
        this.$store.commit('SET_SNACKBAR', {
          show: true,
          type: 'success',
          message: 'Thank you for your valuable feedback!',
        });
      });
  }

  closePopup() {
    // Reset data values and close the popup
    this.rating = null;
    this.message = '';
    this.$store.commit('Feedback/SET_STATE', { key: 'popup', payload: false });
  }
}
